import api from '@/api';
import router from '@/router';

export default {
  namespaced: true,
  state     : {
    order      : [],
    detailOrder: [],
  },
  getters: {
    order      : ({order}) => order,
    detailOrder: ({detailOrder}) => detailOrder,
  },
  mutations: {
    SET_ORDER(state, value) {
      state.order = value;
    },
    SET_ORDER_DETAIL(state, value) {
      state.detailOrder = value;
    },
  },
  actions: {
    async get_order({commit}) {
      try {
        const get_order = await api.prize_shop.get_order();
        commit('SET_ORDER', get_order.data.data);
      } catch (error) {
        if (err.message.indexOf('401')!=-1) {
          router.push({name: 'auth'});
          localStorage.clear();
        }
      }
    },
    async get_order_detail({commit}, id) {
      try {
        const get_order_detail = await api.prize_shop.get_order_detail(id);
        commit('SET_ORDER_DETAIL', get_order_detail.data.data);
      } catch (error) {
        console.error(error);
      }
    },
    async cancel_order({commit}, id) {
      try {
        const get_order_detail = await api.prize_shop.cancel(id);
        const get_order = await api.prize_shop.get_order();
        commit('SET_ORDER', get_order.data.data);
        const get_user_points = await api.user.get_user_points();
        console.log(get_user_points.data);
        commit('profile/user/SPEND_POINTS', get_user_points.data, {root: true});
      } catch (error) {
        console.error(error);
      }
    },
  },
};
